/**
 * Ce avec quoi la valeur d'une condition se saisit, déduit de ce que la condition observe.
 *
 * Une réponse ou une métadonnée énumérable se choisit dans une liste ; une date se prend dans un
 * calendrier, un nombre se tape. Ce n'est pas un détail d'affichage : proposer une liste vide devant
 * une date rendrait la condition impossible à composer.
 */
export enum CONDITION_VALUE_INPUT {
    /** Choix parmi des valeurs connues : statuts d'un indicateur, crans, choix, genre, langue… */
    LIST = 'LIST',

    DATE = 'DATE',

    NUMBER = 'NUMBER',

    /** Texte libre : il n'y a rien à énumérer, la valeur cherchée se tape. */
    TEXT = 'TEXT',

    /** Rien à saisir : la cible n'offre aucune valeur comparable. */
    NONE = 'NONE',
}
